module.exports = "<pre><code class=\"hljs sh\">$ npm <span class=hljs-keyword>install</span> ultra-component <span class=hljs-comment>--save</span>\n</code></pre>";


/*****************
 ** WEBPACK FOOTER
 ** ./src-docs/app/snippets/installation.md
 ** module id = 9
 ** module chunks = 1
 **/